/**
 * 前端项目接口配置
 */
import imgLog from './../assets/img/kangda.png';

export const FRONT_PAGE_EXTEND = `resource/frontPageExtend.json`; // 后端资源配置路径

// 前端配置
export const config = {
    local: `http://${window.location.host}/`, // 本地IP服务
    api: `http://192.168.2.209:8084/iportal/` // 后端api // http://192.168.2.81:8084
};

/**
 * **注意**
 * 生产环境下配置信息全部从后端获取
 */
const CONFIG_API = {
    LOCAL_URL: `${config.local}fe`, // 前端本地路径
    BASE_API: `${config.api}`, // 后端路径
    OAUTH_API: `${config.api}`, // passport服务路径
    UPLOAD_API: `${config.api}/manage/pub/uploadFile`, // 文件上传路径
    IMPORT_API: `${config.api}`, // 文件下载路径
    DEFAULT_PW: '123@ZBglxt', // 默认密码
    SERVICE_API: 'https://lytest11.com/service/', // 客服访问地址  https://app.ly100.cn/kefu/
    PLATFORM_NAME: '教育装备管理公共服务平台', // 页面title
    NODE_ID: 1, // 节点ID
    VERSION: process.env.VERSION, // 版本号
    styleColor: '', // 主题
    showCode: true, // 是否需要验证码  
    passwordEncryption: 'SHA256', // 加密方式可配置为SHA256或SM3,切记加密方式需跟后台保持一致
    otherConfig: { // 是否还需配置其他业务公司
        name: '业务支持',
        company: '广州中长康达信息技术有限公司',
        link: 'www.baidu.com',
        img: imgLog,
        webNumber: '湘ICP备15014574号-1'
    },
    rule: {
        p1: '关于修改安全密码的通知',
        p2: '尊敬的用户：',
        p3: '经密码安全风险排查，部分用户账号的密码存在安全隐患，请立即按规则修改密码！',
        p4: '1．密码长度为8-20个字符，且应同时包含数字、字母和符号。',
        p5: '2．密码不能和账号名相同，不能使用一串规整的数字或字母，不能使用明显的键盘序列或常见的词语或字典词语。',
        p6: '3．每三个月应更改一次密码。',
        p7: '广西壮族自治区教育技术装备中心',
        p8: '2019.7'
    }
};

export default CONFIG_API;


// WEBPACK FOOTER //
// ./src/config/config.default.js